import { render, staticRenderFns } from "./dialog-storage.vue?vue&type=template&id=ef6c3ca4&"
import script from "./dialog-storage.vue?vue&type=script&lang=js&"
export * from "./dialog-storage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports